import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SetFlashMessageRequest } from './setflashmessagerequest';

export class SetFlashMessageAPI extends SixdeeCRBTAPI<SetFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/instant-flash-setting";
    }

    protected getRequestData() 
    {
        console.log("data: " + JSON.stringify(this.getRequest()));
        return {
            msisdn: this.getRequest().getFlashMessageRequest().getMsisdn(),
            flashMessage:this.getRequest().getFlashMessageRequest().getStatusMessage(),
            flashId:this.getRequest().getFlashMessageRequest().getId(),
            offerName:this.getRequest().getFlashMessageRequest().getPlanName(),
            channelId:this.getContext().getUserContext().getChannelId(),
            locale:"my",
            encoding: "false"
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageapi.tsx